// Currency ISO 4217 codes mapped to currency names
export const currencyNames: Record<string, string> = {
    australianDollar: "AUD",
    bulgarianLev: "BGN",
    brazilianReal: "BRL",
    canadianDollar: "CAD",
    swissFranc: "CHF",
    chineseYuan: "CNY",
    czechKoruna: "CZK",
    danishKrone: "DKK",
    euro: "EUR",
    britishPound: "GBP",
    hongKongDollar: "HKD",
    hungarianForint: "HUF",
    indonesianRupiah: "IDR",
    israeliShekel: "ILS",
    indianRupee: "INR",
    icelandicKrona: "ISK",
    japaneseYen: "JPY",
    southKoreanWon: "KRW",
    mexicanPeso: "MXN",
    malaysianRinggit: "MYR",
    norwegianKrone: "NOK",
    newZealandDollar: "NZD",
    philippinePeso: "PHP",
    polishZloty: "PLN",
    romanianLeu: "RON",
    swedishKrona: "SEK",
    singaporeDollar: "SGD",
    thaiBaht: "THB",
    turkishLira: "TRY",
    usDollar: "USD",
    southAfricanRand: "ZAR",
    unitedArabEmiratesDirham: "AED",
    afghanAfghani: "AFN",
    albanianLek: "ALL",
    armenianDram: "AMD",
    angolanKwanza: "AOA",
    argentinePeso: "ARS",
    arubanFlorin: "AWG",
    azerbaijaniManat: "AZN",
    bosniaAndHerzegovinaConvertibleMark: "BAM",
    barbadosDollar: "BBD",
    bangladeshiTaka: "BDT",
    bahrainiDinar: "BHD",
    burundianFranc: "BIF",
    bermudianDollar: "BMD",
    bruneiDollar: "BND",
    boliviano: "BOB",
    bahamianDollar: "BSD",
    bhutaneseNgultrum: "BTN",
    botswanaPula: "BWP",
    belarusianRuble: "BYN",
    belizeDollar: "BZD",
    congoleseFranc: "CDF",
    chileanPeso: "CLP",
    colombianPeso: "COP",
    costaRicanColon: "CRC",
    cubanPeso: "CUP",
    capeVerdeanEscudo: "CVE",
    djiboutianFranc: "DJF",
    dominicanPeso: "DOP",
    algerianDinar: "DZD",
    egyptianPound: "EGP",
    eritreanNakfa: "ERN",
    ethiopianBirr: "ETB",
    fijiDollar: "FJD",
    falklandIslandsPound: "FKP",
    georgianLari: "GEL",
    ghanaianCedi: "GHS",
    gibraltarPound: "GIP",
    gambianDalasi: "GMD",
    guineanFranc: "GNF",
    guatemalanQuetzal: "GTQ",
    guyaneseDollar: "GYD",
    honduranLempira: "HNL",
    haitianGourde: "HTG",
    iraqiDinar: "IQD",
    iranianRial: "IRR",
    jamaicanDollar: "JMD",
    jordanianDinar: "JOD",
    kenyanShilling: "KES",
    kyrgyzstaniSom: "KGS",
    cambodianRiel: "KHR",
    comoroFranc: "KMF",
    northKoreanWon: "KPW",
    kuwaitiDinar: "KWD",
    caymanIslandsDollar: "KYD",
    kazakhstaniTenge: "KZT",
    laoKip: "LAK",
    lebanesePound: "LBP",
    sriLankanRupee: "LKR",
    liberianDollar: "LRD",
    lesothoLoti: "LSL",
    libyanDinar: "LYD",
    moroccanDirham: "MAD",
    moldovanLeu: "MDL",
    malagasyAriary: "MGA",
    macedonianDenar: "MKD",
    myanmarKyat: "MMK",
    mongolianTGrG: "MNT",
    macanesePataca: "MOP",
    mauritanianOuguiya: "MRU",
    mauritianRupee: "MUR",
    maldivianRufiyaa: "MVR",
    malawianKwacha: "MWK",
    mozambicanMetical: "MZN",
    namibianDollar: "NAD",
    nigerianNaira: "NGN",
    nicaraguanCRdoba: "NIO",
    nepaleseRupee: "NPR",
    omaniRial: "OMR",
    panamanianBalboa: "PAB",
    peruvianSol: "PEN",
    papuaNewGuineanKina: "PGK",
    pakistaniRupee: "PKR",
    paraguayanGuaran: "PYG",
    qatariRiyal: "QAR",
    serbianDinar: "RSD",
    russianRuble: "RUB",
    rwandanFranc: "RWF",
    saudiRiyal: "SAR",
    solomonIslandsDollar: "SBD",
    seychellesRupee: "SCR",
    sudanesePound: "SDG",
    saintHelenaPound: "SHP",
    sierraLeoneanLeone: "SLE",
    somalianShilling: "SOS",
    surinameseDollar: "SRD",
    southSudanesePound: "SSP",
    sOTomAndPrNcipeDobra: "STN",
    salvadoranColN: "SVC",
    syrianPound: "SYP",
    swaziLilangeni: "SZL",
    tajikistaniSomoni: "TJS",
    turkmenistanManat: "TMT",
    tunisianDinar: "TND",
    tonganPaAnga: "TOP",
    trinidadAndTobagoDollar: "TTD",
    newTaiwanDollar: "TWD",
    tanzanianShilling: "TZS",
    ukrainianHryvnia: "UAH",
    ugandanShilling: "UGX",
    uruguayanPeso: "UYU",
    uzbekistaniSum: "UZS",
    venezuelanSovereignBolVar: "VES",
    vietnameseNg: "VND",
    vanuatuVatu: "VUV",
    samoanTala: "WST",
    arabAccountingDinar: "XAD",
    cfaFrancBeac: "XAF",
    eastCaribbeanDollar: "XCD",
    caribbeanGuilder: "XCG",
    cfaFrancBceao: "XOF",
    cfpFranc: "XPF",
    sucre: "XSU",
    yemeniRial: "YER",
    zambianKwacha: "ZMW",
};

// Display names for currency keys
export const currencyDisplayNames: Record<string, string> = {
    australianDollar: "Australian Dollar",
    bulgarianLev: "Bulgarian Lev",
    brazilianReal: "Brazilian Real",
    canadianDollar: "Canadian Dollar",
    swissFranc: "Swiss Franc",
    chineseYuan: "Chinese Yuan",
    czechKoruna: "Czech Koruna",
    danishKrone: "Danish Krone",
    euro: "Euro",
    britishPound: "British Pound",
    hongKongDollar: "Hong Kong Dollar",
    hungarianForint: "Hungarian Forint",
    indonesianRupiah: "Indonesian Rupiah",
    israeliShekel: "Israeli Shekel",
    indianRupee: "Indian Rupee",
    icelandicKrona: "Icelandic Krona",
    japaneseYen: "Japanese Yen",
    southKoreanWon: "South Korean Won",
    mexicanPeso: "Mexican Peso",
    malaysianRinggit: "Malaysian Ringgit",
    norwegianKrone: "Norwegian Krone",
    newZealandDollar: "New Zealand Dollar",
    philippinePeso: "Philippine Peso",
    polishZloty: "Polish Zloty",
    romanianLeu: "Romanian Leu",
    swedishKrona: "Swedish Krona",
    singaporeDollar: "Singapore Dollar",
    thaiBaht: "Thai Baht",
    turkishLira: "Turkish Lira",
    usDollar: "US Dollar",
    southAfricanRand: "South African Rand",
    unitedArabEmiratesDirham: "United Arab Emirates dirham",
    afghanAfghani: "Afghan afghani",
    albanianLek: "Albanian lek",
    armenianDram: "Armenian dram",
    angolanKwanza: "Angolan kwanza",
    argentinePeso: "Argentine peso",
    arubanFlorin: "Aruban florin",
    azerbaijaniManat: "Azerbaijani manat",
    bosniaAndHerzegovinaConvertibleMark: "Bosnia and Herzegovina convertible mark",
    barbadosDollar: "Barbados dollar",
    bangladeshiTaka: "Bangladeshi taka",
    bahrainiDinar: "Bahraini dinar",
    burundianFranc: "Burundian franc",
    bermudianDollar: "Bermudian dollar",
    bruneiDollar: "Brunei dollar",
    boliviano: "Boliviano",
    bahamianDollar: "Bahamian dollar",
    bhutaneseNgultrum: "Bhutanese ngultrum",
    botswanaPula: "Botswana pula",
    belarusianRuble: "Belarusian ruble",
    belizeDollar: "Belize dollar",
    congoleseFranc: "Congolese franc",
    chileanPeso: "Chilean peso",
    colombianPeso: "Colombian peso",
    costaRicanColon: "Costa Rican colon",
    cubanPeso: "Cuban peso",
    capeVerdeanEscudo: "Cape Verdean escudo",
    djiboutianFranc: "Djiboutian franc",
    dominicanPeso: "Dominican peso",
    algerianDinar: "Algerian dinar",
    egyptianPound: "Egyptian pound",
    eritreanNakfa: "Eritrean nakfa",
    ethiopianBirr: "Ethiopian birr",
    fijiDollar: "Fiji dollar",
    falklandIslandsPound: "Falkland Islands pound",
    georgianLari: "Georgian lari",
    ghanaianCedi: "Ghanaian cedi",
    gibraltarPound: "Gibraltar pound",
    gambianDalasi: "Gambian dalasi",
    guineanFranc: "Guinean franc",
    guatemalanQuetzal: "Guatemalan quetzal",
    guyaneseDollar: "Guyanese dollar",
    honduranLempira: "Honduran lempira",
    haitianGourde: "Haitian gourde",
    iraqiDinar: "Iraqi dinar",
    iranianRial: "Iranian rial",
    jamaicanDollar: "Jamaican dollar",
    jordanianDinar: "Jordanian dinar",
    kenyanShilling: "Kenyan shilling",
    kyrgyzstaniSom: "Kyrgyzstani som",
    cambodianRiel: "Cambodian riel",
    comoroFranc: "Comoro franc",
    northKoreanWon: "North Korean won",
    kuwaitiDinar: "Kuwaiti dinar",
    caymanIslandsDollar: "Cayman Islands dollar",
    kazakhstaniTenge: "Kazakhstani tenge",
    laoKip: "Lao kip",
    lebanesePound: "Lebanese pound",
    sriLankanRupee: "Sri Lankan rupee",
    liberianDollar: "Liberian dollar",
    lesothoLoti: "Lesotho loti",
    libyanDinar: "Libyan dinar",
    moroccanDirham: "Moroccan dirham",
    moldovanLeu: "Moldovan leu",
    malagasyAriary: "Malagasy ariary",
    macedonianDenar: "Macedonian denar",
    myanmarKyat: "Myanmar kyat",
    mongolianTGrG: "Mongolian tögrög",
    macanesePataca: "Macanese pataca",
    mauritanianOuguiya: "Mauritanian ouguiya",
    mauritianRupee: "Mauritian rupee",
    maldivianRufiyaa: "Maldivian rufiyaa",
    malawianKwacha: "Malawian kwacha",
    mozambicanMetical: "Mozambican metical",
    namibianDollar: "Namibian dollar",
    nigerianNaira: "Nigerian naira",
    nicaraguanCRdoba: "Nicaraguan córdoba",
    nepaleseRupee: "Nepalese rupee",
    omaniRial: "Omani rial",
    panamanianBalboa: "Panamanian balboa",
    peruvianSol: "Peruvian sol",
    papuaNewGuineanKina: "Papua New Guinean kina",
    pakistaniRupee: "Pakistani rupee",
    paraguayanGuaran: "Paraguayan guaraní",
    qatariRiyal: "Qatari riyal",
    serbianDinar: "Serbian dinar",
    russianRuble: "Russian ruble",
    rwandanFranc: "Rwandan franc",
    saudiRiyal: "Saudi riyal",
    solomonIslandsDollar: "Solomon Islands dollar",
    seychellesRupee: "Seychelles rupee",
    sudanesePound: "Sudanese pound",
    saintHelenaPound: "Saint Helena pound",
    sierraLeoneanLeone: "Sierra Leonean leone (new leone)",
    somalianShilling: "Somalian shilling",
    surinameseDollar: "Surinamese dollar",
    southSudanesePound: "South Sudanese pound",
    sOTomAndPrNcipeDobra: "São Tomé and Príncipe dobra",
    salvadoranColN: "Salvadoran colón",
    syrianPound: "Syrian pound",
    swaziLilangeni: "Swazi lilangeni",
    tajikistaniSomoni: "Tajikistani somoni",
    turkmenistanManat: "Turkmenistan manat",
    tunisianDinar: "Tunisian dinar",
    tonganPaAnga: "Tongan paʻanga",
    trinidadAndTobagoDollar: "Trinidad and Tobago dollar",
    newTaiwanDollar: "New Taiwan dollar",
    tanzanianShilling: "Tanzanian shilling",
    ukrainianHryvnia: "Ukrainian hryvnia",
    ugandanShilling: "Ugandan shilling",
    uruguayanPeso: "Uruguayan peso",
    uzbekistaniSum: "Uzbekistani sum",
    venezuelanSovereignBolVar: "Venezuelan sovereign bolívar",
    vietnameseNg: "Vietnamese đồng",
    vanuatuVatu: "Vanuatu vatu",
    samoanTala: "Samoan tala",
    arabAccountingDinar: "Arab Accounting Dinar[18]",
    cfaFrancBeac: "CFA franc BEAC",
    eastCaribbeanDollar: "East Caribbean dollar",
    caribbeanGuilder: "Caribbean guilder",
    cfaFrancBceao: "CFA franc BCEAO",
    cfpFranc: "CFP franc (franc Pacifique)",
    yemeniRial: "Yemeni rial",
    zambianKwacha: "Zambian kwacha",
};
